import { defineMessages } from 'react-intl';

export const reconnectChatMessages = defineMessages({
	chat__disconnected: {
		id: 'footer.chat__disconnected',
		defaultMessage: 'Disconnected from server',
	},
	chat__reconnecting: {
		id: 'footer.chat__reconnecting',
		defaultMessage: 'We are trying to reconnect to the server. Please wait...',
	},
	chat__error: {
		id: 'footer.chat__error',
		defaultMessage:
			'We had problem during reconnection. Please click here to retry',
	},
});
